import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const notificationService = {
  getEmailLogs: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/notifications/email-logs`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getWhatsAppLogs: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/notifications/whatsapp-logs`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getEmailLogById: async (id) => {
    const logs = await notificationService.getEmailLogs({ limit: 200 });
    const list = Array.isArray(logs) ? logs : logs?.data || [];
    return list.find((l) => String(l.id) === String(id)) || null;
  },

  getWhatsAppLogById: async (id) => {
    const logs = await notificationService.getWhatsAppLogs({ limit: 200 });
    const list = Array.isArray(logs) ? logs : logs?.data || [];
    return list.find((l) => String(l.id) === String(id)) || null;
  },

  sendBookingReceiptEmail: async (bookingReceiptData) => {
    const response = await axios.post(
      `${API_BASE_URL}/notifications/booking-receipt/email`,
      bookingReceiptData
    );
    return response.data;
  },
};

export default notificationService;
